import { Card } from "@coherence-design-system/controls";
import { IBreadcrumbProps, Pivot, PivotItem } from "@fluentui/react";
import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import FavoriteCustomersGridComponent from "../components/MyFavorites/FavoriteCustomersGridComponent";
import FavoritePartnersGridComponent from "../components/MyFavorites/FavoritePartnersGridComponent";
import FavoriteProductsGridComponent from "../components/MyFavorites/FavoriteProductsGridComponent";
import FavoriteReportsGridComponent from "../components/MyFavorites/FavoriteReportsGridComponent";
import { logPageView } from "../helper/AppInsightsHelper";
import { CustomBreadcrumb } from "../SharedComponents/CustomBreadcrumb";
import { useGetUIEnablementsSettingsQuery } from "../slices/Home.slice";
import { buildDisabledFeatureLookup } from "../Utils/js-common";

const breadcrumbStyles = {
  root: {
    fontSize: "14px",
    margin: 0,
    paddingLeft: "8px",
    "--itemLink-color": "rgb(0, 120, 212)"
  },
  item: {
    fontSize: "inherit"
  },
  itemLink: {
    fontSize: "inherit",
    color: "var(--itemLink-color)",
    ":hover": {
      background: "none",
      textDecoration: "underline",
      color: "var(--itemLink-color)"
    }
  }
};

const FAVORITE_TABS = [
  { headerText: "Favorite Customers", itemKey: "0" },
  { headerText: "Favorite Products", itemKey: "1" },
  { headerText: "Favorite Reports", itemKey: "2" },
  { headerText: "Favorite Partners", itemKey: "3" }
] as const;

export default function MyFavorites() {
  const navigate = useNavigate();
  const key = "my-favorites-bc";
  const bcrops: IBreadcrumbProps = {
    items: [
      { text: "Home", key: "home", onClick: () => navigate("/") },
      { text: "My Favorites", key: "my-favorites", isCurrentItem: true }
    ],
    styles: breadcrumbStyles
  };
  const [activeTab, setActiveTab] = useState<string | undefined>("0");
  const uiEnablementData = useGetUIEnablementsSettingsQuery(undefined)?.data || [];
  const disabled = buildDisabledFeatureLookup(uiEnablementData);
  const disabledTabOptions = disabled["tab"] || [];
  const filteredTabOptions = FAVORITE_TABS.filter(
    ({ headerText }) =>
      !disabledTabOptions
        .filter(({ feature }) => feature === "My Favorites")
        .map(({ tab }) => tab)
        .includes(headerText)
  );

  // Envents
  const handleTabChange = (item?: PivotItem) => {
    setActiveTab(item?.props.itemKey);
  };

  // Hooks
  useEffect(() => {
    logPageView("My Favorites Page", window.location.href);
  }, []);

  return (
    <div className="mainCard" style={{ margin: 10 }}>
      <Card header={<CustomBreadcrumb {...bcrops} key={key} />}>
        <Pivot selectedKey={activeTab} onLinkClick={handleTabChange} aria-label="favorites tabs">
          {filteredTabOptions.map((tab) => (
            <PivotItem key={tab.itemKey} headerText={tab.headerText} itemKey={tab.itemKey} />
          ))}
        </Pivot>
        <Box sx={{ mt: 2 }}>
          {activeTab === "0" && <FavoriteCustomersGridComponent />}
          {activeTab === "1" && <FavoriteProductsGridComponent />}
          {activeTab === "2" && <FavoriteReportsGridComponent />}
          {activeTab === "3" && <FavoritePartnersGridComponent />}
        </Box>
      </Card>
    </div>
  );
}
